export const PHONE_NUMBER = '855-678-6248';

export const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=com.mysunbitnative';
export const IOS_STORE_URL = 'https://apps.apple.com/us/app/mysunbit/id1551590090';



// WEBPACK FOOTER //
// ./src/constants/sunbit.js